import React from 'react';
import { motion } from 'framer-motion';
import { FaLink, FaBolt, FaCheckCircle } from 'react-icons/fa';

const steps = [
  {
    number: 1,
    title: 'Paste URL',
    description: 'Copy the link of the video you want to download and paste it into the input box above.',
    icon: FaLink,
    color: 'from-purple-500 to-purple-600',
  },
  {
    number: 2,
    title: 'Analyze & Process',
    description: 'Our powerful API will quickly process the video and retrieve all available formats and qualities.',
    icon: FaBolt,
    color: 'from-pink-500 to-pink-600',
  },
  {
    number: 3,
    title: 'Download & Enjoy',
    description: 'Select your desired quality and click the download button to save the file directly to your device.',
    icon: FaCheckCircle,
    color: 'from-purple-500 to-pink-500',
  },
];

const HowItWorks = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-4xl md:text-5xl font-bold text-center mb-12 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent"
      >
        How It Works
      </motion.h2>

      <div className="grid md:grid-cols-3 gap-6">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-[#1a1a3e] border border-gray-800 rounded-2xl p-8 hover:border-purple-500 transition-all"
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-xl flex items-center justify-center mb-6 mx-auto`}>
                <Icon className="text-white" size={28} />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3 text-center">
                {step.number}. {step.title}
              </h3>
              
              <p className="text-gray-400 text-center leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default HowItWorks;
